export const ddmmyy: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
}

export const ddMM: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
}

export const MM: Intl.DateTimeFormatOptions = {
  month: 'short',
}

export const mmYYYY: Intl.DateTimeFormatOptions = {
  month: 'long',
  year: 'numeric',
}

export const mmyyyy: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  year: 'numeric',
}

export const ddmmyyyyhhmm: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
}

export const ddMMyyyyhhmm: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
}

export const ddmmmmyyyy: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
}

export const yyyy: Intl.DateTimeFormatOptions = {
  year: 'numeric',
}

export const ddmmyyyyhhmmss: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
}
